import { ToastType } from "./Toast.tsx";

export interface Toast {
  id: string;
  type: ToastType;
  message: string;
  duration?: number;
}

class MessageService {
  private listeners: ((toasts: Toast[]) => void)[] = [];
  private toasts: Toast[] = [];

  private notify() {
    this.listeners.forEach((listener) => listener([...this.toasts]));
  }

  private addToast(type: ToastType, message: string, duration?: number) {
    const id = Date.now().toString() + Math.random().toString(36).substr(2, 9);
    const toast: Toast = {
      id,
      type,
      message,
      duration,
    };

    this.toasts.push(toast);
    this.notify();

    // 自动移除
    if (duration !== 0) {
      setTimeout(() => {
        this.removeToast(id);
      }, duration || 5000);
    }
  }

  private removeToast(id: string) {
    this.toasts = this.toasts.filter((toast) => toast.id !== id);
    this.notify();
  }

  subscribe(listener: (toasts: Toast[]) => void) {
    this.listeners.push(listener);
    return () => {
      this.listeners = this.listeners.filter((l) => l !== listener);
    };
  }

  remove(id: string) {
    this.removeToast(id);
  }

  success(message: string, duration?: number) {
    this.addToast("success", message, duration);
  }

  error(message: string, duration?: number) {
    this.addToast("error", message, duration);
  }

  warning(message: string, duration?: number) {
    this.addToast("warning", message, duration);
  }

  info(message: string, duration?: number) {
    this.addToast("info", message, duration);
  }

  clear() {
    this.toasts = [];
    this.notify();
  }
}

const messageService = new MessageService();

export default messageService;
